// extracted by mini-css-extract-plugin
var _1 = "Rui25eNwPhWyfbwCardt";
export { _1 as "carouselWrapper" }
